import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import errorManage from "../../errorManage";
import CapacitacionServices from "./capacitacion.services";
import toastr from "toastr";
import moment from "moment";
import gestorDocumentalServices from "../../gestorDocumental/gestorDocumental.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCapacitaciones = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CAPACITACION_LISTADO,
      payload: true,
    });
    const resp = await CapacitacionServices.getCapacitaciones(filters);
    dispatch({
      type: actions.GET_CAPACITACION_LISTADO,
      payload: {
        capacitacionList: resp.data.data,
        capacitacionListLength: resp.data.count,
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_CAPACITACION_LISTADO,
      payload: false,
    });
  }
};

export const getCapacitacion = (filters, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CAPACITACION,
      payload: true,
    });
    const resp = await CapacitacionServices.getCapacitacion(filters, id);
    dispatch({
      type: actions.GET_CAPACITACION,
      payload: {
        capacitacion: resp.data,
        bloques: resp.data.workflow_bloques,
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_CAPACITACION,
      payload: false,
    });
  }
};

export const resetBloque = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BLOQUE,
      payload: true,
    });

    dispatch({
      type: actions.GET_BLOQUE,
      payload: {
        bloque: {},
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BLOQUE,
      payload: false,
    });
  }
};

export const getBloque = (filters, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BLOQUE,
      payload: true,
    });
    const resp = await CapacitacionServices.getBloque(filters, id);
    dispatch({
      type: actions.GET_BLOQUE,
      payload: {
        bloque: resp.data,
        tareas: resp.data.workflow_tareas
          ? resp.data.workflow_tareas.sort((a, b) => {
              if (a.posicion !== null && b.posicion !== null) {
                if (
                  parseInt(a.posicion) === parseInt(b.posicion) &&
                  moment(a.fecha_fin) > moment(b.fecha_fin)
                ) {
                  return 1;
                }

                if (
                  parseInt(a.posicion) === parseInt(b.posicion) &&
                  moment(a.fecha_fin) < moment(b.fecha_fin)
                ) {
                  return -1;
                }

                if (parseInt(a.posicion) < parseInt(b.posicion)) {
                  return -1;
                }
              }
              if (moment(a.fecha_fin) > moment(b.fecha_fin)) {
                return 1;
              }
              if (moment(a.fecha_fin) < moment(b.fecha_fin)) {
                return -1;
              }
            })
          : null,
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BLOQUE,
      payload: false,
    });
  }
};

export const saveBloqueDocGD =
  (dataGD, editItem, index, exist, bloq) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: true,
      });
      const { bloque, tareas } = getState().capacitacion;
      if (exist) {
        const respGD = await gestorDocumentalServices.saveDocument(dataGD);
        const respPUT = await CapacitacionServices.editTarea(editItem.id, {
          // ...editItem,
          bloque: bloq,
          archivos_gestor: respGD.data.resultado.id,
        });
        bloque.workflow_tareas[index] = respPUT.data;
        tareas[index] = respPUT.data;
        dispatch({
          type: actions.GET_BLOQUE,
          payload: {
            bloque: bloque,
            tareas: tareas,
          },
        });
      } else {
        dispatch({
          type: actions.GET_BLOQUE,
          payload: {
            bloque: bloque,
            tareas: tareas,
          },
        });
      }
      toastr.success(messages.successMessage);
      // const { bloque, tareas } = getState().capacitacion;
      // try {
      //   const respGD = await gestorDocumentalServices.saveDocument(data);
      //   const respuestGD = respGD.data;
      //   editItem.archivo_gestor = respuestGD;
      //   editItem.archivos_gestor = respuestGD.id;

      //   tareas[index] = editItem;
      //   dispatch({
      //     type: actions.GET_BLOQUE,
      //     payload: {
      //       bloque: bloque,
      //       tareas: tareas,
      //     },
      //   });
      //   toastr.success(messages.successMessage);
      // } catch (error) {
      //   console.log(error);
      // }
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: false,
      });
    }
  };

export const editBloqueDocGD =
  (dataGD, editItem, index, arGD, exist, bloq) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: true,
      });
      const { bloque, tareas } = getState().capacitacion;
      if (exist) {
        const respGD = await gestorDocumentalServices.editDocument(
          arGD,
          dataGD
        );
        const respPUT = await CapacitacionServices.editTarea(editItem.id, {
          // ...editItem,
          bloque: bloq,
          archivos_gestor: respGD.data.id,
        });
        bloque.workflow_tareas[index] = respPUT.data;
        tareas[index] = respPUT.data;
        dispatch({
          type: actions.GET_BLOQUE,
          payload: {
            bloque: bloque,
            tareas: tareas,
          },
        });
        toastr.success(messages.successMessage);
      } else {
        dispatch({
          type: actions.GET_BLOQUE,
          payload: {
            bloque: bloque,
            tareas: tareas,
          },
        });
      }
      // const { bloque, tareas } = getState().capacitacion;
      // try {
      //   const respGD = await gestorDocumentalServices.editDocument(
      //     parseInt(id),
      //     data
      //   );
      //   const respuestGD = respGD.data;
      //   editItem.archivo_gestor = respuestGD;
      //   editItem.archivos_gestor = respuestGD.id;

      //   tareas[index] = editItem;
      //   dispatch({
      //     type: actions.GET_BLOQUE,
      //     payload: {
      //       bloque: bloque,
      //       tareas: tareas,
      //     },
      //   });
      //   toastr.success(messages.successMessage);
      // } catch (error) {
      //   console.log(error);
      // }
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: false,
      });
    }
  };

export const getBloqueActual = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BLOQUE_ACTUAL,
      payload: true,
    });

    const resp = await CapacitacionServices.getBloqueActual(data);

    dispatch({
      type: actions.GET_BLOQUE_ACTUAL,
      payload: {
        bloque_actual: resp.data.bloque_actual,
        bloque_anterior: resp.data.bloque_anterior,
        bloque_siguiente: resp.data.bloque_siguiente,
      },
    });
    dispatch(getBloque({}, resp.data.bloque_actual.id));
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BLOQUE_ACTUAL,
      payload: false,
    });
  }
};

export const getBloqueAnteriorAnterior =
  (data) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_BLOQUE_ANTERIOR_ANTERIOR,
        payload: true,
      });

      const resp = await CapacitacionServices.getBloqueAnteriorAnterior(data);

      dispatch({
        type: actions.GET_BLOQUE_ANTERIOR_ANTERIOR,
        payload: {
          bloque_anterior_anterior: resp.data,
        },
      });
    } catch (ex) {
      let message = "";
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (Array.isArray(ex.response.data)) {
                ex.response.data.forEach((item) => {
                  toastr.error(item);
                });
              } else {
                toastr.error(ex.response.data);
              }
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } finally {
      dispatch({
        type: actions.LOADING_BLOQUE_ANTERIOR_ANTERIOR,
        payload: false,
      });
    }
  };

export const getBienvenida =
  (filters, history, data, index, type) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_VENTANA_BIENVENIDA,
        payload: true,
      });
      await CapacitacionServices.getVentanaBienvenida(filters);

      history.push(
        `/capacitacion/bienvenida/${data.nombre}/${data.id}/${index}/${type}`
      );
    } catch (ex) {
      let message = "";
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (Array.isArray(ex.response.data)) {
                ex.response.data.forEach((item) => {
                  toastr.error(item);
                });
              } else {
                toastr.error(ex.response.data);
              }
              break;
            case 404:
              history.push(
                `/capacitacion/${data.nombre}/${data.id}/${index}/${type}`
              );
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } finally {
      dispatch({
        type: actions.LOADING_VENTANA_BIENVENIDA,
        payload: false,
      });
    }
  };

export const enviarCorreo = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CAPACITACION,
      payload: true,
    });
    await CapacitacionServices.enviarCorreo(filters);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            console.error(ex.response.data.mensaje);
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data.correos_no_enviados) {
              toastr.error(
                ex.response.data.correos_no_enviados[0],
                "Correo no Enviado",
                { closeButton: true, timeOut: 0, extendedTimeOut: 0 }
              );
            } else if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              toastr.error(messages.errorMessage + ex.response.statusText);
            }
            //console.error(ex.response.data.mensaje);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CORREO_FAIL,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CAPACITACION,
      payload: false,
    });
  }
};

export const estadoActividad = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_ESTADO_ACTIVIDAD,
      payload: true,
    });
    await CapacitacionServices.estadoActividad(data);
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data.mensaje);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_ESTADO_ACTIVIDAD,
      payload: false,
    });
  }
};

export const editTarea = (id, data, bloqueSeleccionado) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_SUBIR_ARCHIVO,
      payload: true,
    });
    await CapacitacionServices.editTarea(id, data);

    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_SUBIR_ARCHIVO,
      payload: false,
    });
  }
};

export const editTareaSeguimiento =
  (id, data, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: true,
      });
      const resp = await CapacitacionServices.editTarea(id, data);

      const { bloque, tareas, bandera } = getState().capacitacion;
      bloque.workflow_tareas[index] = resp.data;
      tareas[index] = resp.data;

      dispatch({
        type: actions.GET_BLOQUE,
        payload: {
          bloque: bloque,
          tareas: tareas,
          bandera: !bandera,
        },
      });

      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = "";
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (Array.isArray(ex.response.data)) {
                ex.response.data.forEach((item) => {
                  toastr.error(item);
                });
              } else {
                toastr.error(ex.response.data);
              }
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } finally {
      dispatch({
        type: actions.LOADING_BLOQUE,
        payload: false,
      });
    }
  };
